import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white pt-24 pb-12 px-6 border-t border-white/5" data-id="element-34">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 mb-20" data-id="element-35">
        <div className="space-y-6" data-id="element-36">
          <div className="flex items-center gap-4" data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/58tNa4GTAAmpR1FoCHN2wS/Image_(57).jpg" alt="Sips & Nibblez Logo" className="h-16 w-16 rounded-full object-cover border-2 border-[#992f74]/30" data-id="element-38" />
            <span className="text-lg font-montserrat font-bold tracking-[0.3em] uppercase" data-id="element-39">
              Sips and Nibblez
            </span>
          </div>
          <p className="text-white/40 text-sm leading-relaxed max-w-xs" data-id="element-40">
            By Zobug. Elevating your celebrations with bespoke cocktails,
            mocktails, and gourmet desserts.
          </p>
        </div>

        <div className="space-y-6" data-id="element-41">
          <h4 className="text-[11px] font-montserrat font-bold uppercase tracking-[0.4em] text-[#992f74]" data-id="element-42">
            Connect
          </h4>
          <div className="space-y-4 text-white/70 font-light text-sm font-montserrat" data-id="element-43">
            <p data-id="element-44">
              11705 Berry Rd Suite 301-7
              <br data-id="element-45" />
              Waldorf, MD 20603
              <br data-id="element-46" />
              United States
            </p>
            <a href="tel:+12403563070" className="block hover:text-[#992f74] transition-colors" data-id="element-47">
              240 356 3070
            </a>
            <a href="mailto:booking@sipsandnibblez.com" className="block hover:text-[#992f74] transition-colors" data-id="element-48">
              booking@sipsandnibblez.com
            </a>
          </div>
        </div>

        <div className="space-y-6" data-id="element-49">
          <h4 className="text-[11px] font-montserrat font-bold uppercase tracking-[0.4em] text-[#992f74]" data-id="element-50">
            Legal
          </h4>
          <nav className="flex flex-col space-y-3 text-sm text-white/40" data-id="element-51">
            <a href="#" className="hover:text-white transition-colors" data-id="element-52">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-53">
              Cookie Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-54">
              Terms of Service
            </a>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-55">
        <p className="text-[10px] uppercase tracking-widest text-white/30" data-id="element-56">
          © 2026 Sips and Nibblez by Zobug. All Rights Reserved.
        </p>
        <div className="flex flex-wrap gap-4 md:gap-8 text-[10px] uppercase tracking-widest text-white/30" data-id="element-57">
          <a href="https://www.facebook.com/sipsandnibblezbyzobug/" target="_blank" rel="noopener noreferrer" className="hover:text-[#992f74] transition-colors" data-id="element-58">
            Facebook
          </a>
          <a href="https://www.instagram.com/sipsandnibblez/" target="_blank" rel="noopener noreferrer" className="hover:text-[#992f74] transition-colors" data-id="element-59">
            Instagram
          </a>
          <a href="https://www.tiktok.com/@sipsandnibblez?lang=en" target="_blank" rel="noopener noreferrer" className="hover:text-[#992f74] transition-colors" data-id="element-60">
            TikTok
          </a>
          <a href="https://share.google/2NWTxEYaqi83HDooq" target="_blank" rel="noopener noreferrer" className="hover:text-[#992f74] transition-colors" data-id="element-61">
            Google
          </a>
        </div>
      </div>
    </footer>;
}